import * as yup from 'yup';

/**
 * Form data type for adding plots
 */
export interface AddPlotFormData {
  name: string;
  plotNumber: string;
}

/**
 * Validation schema for adding plots
 * Following form-architecture.md Yup patterns
 */
export const addPlotSchema: yup.ObjectSchema<AddPlotFormData> = yup.object({
  name: yup
    .string()
    .required('Plot name is required')
    .max(100, 'Plot name cannot exceed 100 characters'),
  plotNumber: yup
    .string()
    .required('Plot number is required')
    .max(50, 'Plot number cannot exceed 50 characters'),
});
